export default __webpack_public_path__ + "static/JaneGoodallsreasonstobehopeful-5091c46a9a227bf248e1530c37053e5a.jpg";